import { render, staticRenderFns } from "./ButtonLineChat.vue?vue&type=template&id=b348279a&scoped=true&"
import script from "./ButtonLineChat.vue?vue&type=script&lang=js&"
export * from "./ButtonLineChat.vue?vue&type=script&lang=js&"
import style0 from "./ButtonLineChat.vue?vue&type=style&index=0&id=b348279a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b348279a",
  null
  
)

export default component.exports